const formaterDemandeArmeHeritee = (dataForm) => {
    return {
        nomPersonneDecedee: dataForm.nomPersonneDecedee,
        prenomPersonneDecedee: dataForm.prenomPersonneDecedee,
        dateNaissancePersonneDecedee: dataForm.dateNaissancePersonneDecedee,
        lieuNaissancePersonneDecedee: dataForm.lieuNaissancePersonneDecedee,
        dateDecesPersonneDecedee: dataForm.dateDecesPersonneDecedee,
        numeroSiaPersonneDecedee: dataForm.numeroSiaPersonneDecedee,
        numeroEncodage: dataForm.numeroEncodage,
        numeroRga: dataForm.numeroRga,
        numeroCarcasse: !dataForm.hasNumeroSerie ? dataForm.numeroCarcasse : null,
        armeIsNeutralisee: dataForm.armeIsNeutralisee,
    };
};

export default formaterDemandeArmeHeritee;
